// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error[data-v-492a1798] {\n  margin-top: 2px !important;\n  color: #c14e4e;\n  font-size: 14px;\n  min-height: 30px;\n}", ""]);
// Exports
module.exports = exports;
